export default function ArrowIcon() {
  return (
    <img src="/static/img/arrow.svg" alt="矢印" className="block w-[13.5px] md:transform md:-rotate-90" />
  );
}
